import { useTranslation } from 'react-i18next';

import type { ThreadSummary } from '../../types';
import { Avatar } from '@/shared/ui/atoms/Avatar';
import { formatRelativeTime } from '@/shared/utils/time';
import './ThreadList.styl';

type Props = { threads: ThreadSummary[]; activeId: string | null; onSelect: (id: string) => void };

export function ThreadList({ threads, activeId, onSelect }: Props) {
  const { t: tr } = useTranslation(undefined, { keyPrefix: 'messages' });
  return (
    <div className="f-threads" role="list" aria-label={tr('threads')}>
      {threads.map((t) => (
        <button key={t.id} type="button" role="listitem" className={t.id === activeId ? 'f-threads__item f-threads__item--active' : 'f-threads__item'} onClick={() => onSelect(t.id)} aria-current={t.id === activeId || undefined}>
          <Avatar initials={t.initials} color={t.color} size={36} square />
          <span className="f-threads__body">
            <span className="f-threads__top">
              <span className="f-threads__name">{t.name}</span>
              {t.lastMessage ? <span className="f-threads__time u-mono">{formatRelativeTime(t.lastMessage.sentAt)}</span> : null}
            </span>
            <span className="f-threads__last">{t.lastMessage?.body ?? tr('noMessages')}</span>
          </span>
          {t.unread > 0 ? <span className="f-threads__badge" aria-label={tr('unread', { count: t.unread })}>{t.unread}</span> : null}
        </button>
      ))}
      {threads.length === 0 ? <div className="f-threads__empty">{tr('noThreads')}</div> : null}
    </div>
  );
}
